import { nativeApplicationVersion, nativeBuildVersion } from "expo-application";
import ExpoConstants from "expo-constants";

import ProcessEnvironment from "@/constants/ProcessEnvironment";
import { isProductionEnvironment } from "@/utils/environment.util";
import { isWeb } from "@/utils/platform.util";

const { DeploymentEnvironment: CurrentEnvironment } = ProcessEnvironment;

// on native, at build/deploy time, Fastlane writes the version to the native binary, and expo-application reads it in this repo
// on web, at build/deploy time, CI mirrors Fastlane's logic to set a version to EXPO_PUBLIC_WEB_APP_VERSION/app.config.js, read here
const AppVersion = isWeb()
  ? ExpoConstants.expoConfig?.version || "0.0.0"
  : nativeApplicationVersion || "0.0.0";

const BuildVersion = nativeBuildVersion || "0";

const getVersionLabel = () => {
  if (isProductionEnvironment()) {
    return `v${AppVersion}`;
  }
  if (isWeb()) {
    return `v${AppVersion} - ${CurrentEnvironment}`;
  }
  return `v${AppVersion} (${BuildVersion}) - ${CurrentEnvironment}`;
};

const isAppOutdated = ({
  appMinimumSupportedVersion,
}: {
  appMinimumSupportedVersion?: string;
}) => {
  // concept of outdated/minimum version does not apply to web (users have no control over web's version)
  if (!appMinimumSupportedVersion || isWeb()) {
    return false;
  }

  const isOutdated =
    AppVersion.localeCompare(appMinimumSupportedVersion, undefined, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      numeric: true,
      sensitivity: "base",
    }) < 0;

  return isOutdated;
};

export { AppVersion, getVersionLabel, isAppOutdated };
